<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { useScreen } from '@consumer/helpers/screen'
import GiftlyLogo from './Header/GiftlyLogo.vue'
import MainContainer from './Header/MainContainer.vue'
import UserMenu from './Header/UserMenu.vue'

defineEmits(['close'])

const __$temp_1 = (useScreen()),
  isDesktop = _toRef(__$temp_1, 'isDesktop');
</script>

<template>
  <div class="checkout-header w-full z-navbar bg-white">
    <V2Container class="!p-0 w-full">
      <MainContainer
        id="new-header"
        :style="{ padding: isDesktop ? '2.75rem 0.5rem' : '2.25rem 0.75rem' }"
      >
        <div class="w-full flex items-center justify-between h-15 relative">
          <h1
            class="text-lg pointer-events-none lg:text-2xl text-center absolute inset-0 h-full"
            style="line-height: 3.75rem;"
          >
            Secure Checkout
          </h1>
          <GiftlyLogo/>
          <UserMenu/>
        </div>
      </MainContainer>
    </V2Container>
  </div>
</template>
